module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<tr>\n  <td class=\'support-year\'>' +
((__t = ( year )) == null ? '' : __t) +
'</td>\n  <td class=\'support-recipient\'>\n      ';
 if ( entity_id != null ) { ;
__p += '\n          <a href="' +
((__t = ( window.URLSchemeHandlerInstance.linkToEntity(entity_id) )) == null ? '' : __t) +
'">' +
((__t = ( recipient )) == null ? '' : __t) +
'</a>\n      ';
 } else { ;
__p += '\n          ' +
((__t = ( recipient )) == null ? '' : __t) +
'\n      ';
 } ;
__p += '\n  </td>\n  <td class=\'support-amount-allocated\'>' +
((__t = ( number_with_commas(amount_allocated) )) == null ? '' : __t) +
'</td>\n  <td class=\'support-amount_supported\'>' +
((__t = ( number_with_commas(amount_supported) )) == null ? '' : __t) +
'</td>\n  <td class=\'support-kind\'>' +
((__t = ( kind )) == null ? '' : __t) +
'</td>\n  <td class=\'support-more\'>\n    <span class=\'support-num_used\'>\n      ';
 if (kind=='תמיכה בפרט' || num_used > 1) { ;
__p += '\n      ' +
((__t = ( num_used )) == null ? '' : __t) +
' נתמכים\n      ';
 } ;
__p += '\n    </span>\n    <span class=\'support-company_id\'>\n      ';
 if ( entity_kind == "company" ) { ;
__p += '\n      מספר חברה: ' +
((__t = ( entity_id )) == null ? '' : __t) +
'\n      ';
 } ;
__p += '\n    </span>\n    <span class=\'support-ngo_id\'>\n      ';
 if ( entity_kind == "association" ) { ;
__p += '\n      מספר עמותה: ' +
((__t = ( entity_id )) == null ? '' : __t) +
'\n      ';
 } ;
__p += '\n    </span>\n  </td>\n</tr>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/single-support-item.html
// module id = 143
// module chunks = 0